export abstract class Api {

  constructor(public nonce: string){

  }

  private filterError(data: any) {
    if (data.code && data.data.messages) throw data.data;
    if (data.code) throw Error(data.message);
    return data;
  }

  protected post(path: string, content: any){
    return fetch(path, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-WP-Nonce": this.nonce,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(content)
    }).then(response => response.json()
      .catch(e=>{throw { errors: [ "Unexpected error" ]}
      })).then(this.filterError);
  }
}


// WEBPACK FOOTER //
// ./src/common/Api.tsx